import { useEffect } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { ClientRoutes, FeatureFlags } from "@common/constants";
import { useRouter } from "@common/hooks";

const useServiceLinePagesGate = () => {
  const router = useRouter();
  const flags = useFlags();
  const isEnabled = flags[FeatureFlags.SERVICE_LINE_PAGES];

  useEffect(() => {
    if (isEnabled === false) {
      router.push(ClientRoutes.Overview);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnabled]);

  return Boolean(isEnabled);
};

const useServiceLinePages = () => {
  const flags = useFlags();
  const isServiceLinePagesEnabled = flags[FeatureFlags.SERVICE_LINE_PAGES];

  return { isServiceLinePagesEnabled };
};

export { useServiceLinePagesGate, useServiceLinePages };
